// frontend/src/pages/ConsumerLaw.js

import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaAngleDoubleLeft, FaAngleDoubleRight } from 'react-icons/fa'; // Import icons from react-icons
import '../styles/LawDisplayPage.css';

const CivilLaw = () => {
  const navigate = useNavigate();
  const buttonContainerRef1 = useRef(null);
  const buttonContainerRef2 = useRef(null);

  const scrollLeft = (ref) => {
    ref.current.scrollBy({ left: -300, behavior: 'smooth' });
  };

  const scrollRight = (ref) => {
    ref.current.scrollBy({ left: 300, behavior: 'smooth' });
  };

  return (
    <div className="law-page">
      {/* Heading */}
      <h1>Indian Consumer Law</h1>

      {/* Details of Indian Corporate Law */}
      <div className="content-section">
        <h2>Details of Indian Consumer Law</h2>
        <p>
        The Consumer Protection Act in India protects consumers from being cheated or harassed by suppliers. 
        It also aims to protect consumers 
        from unfair or restrictive trade practices and deficiencies in goods or services
        </p>
        <p>
        The 8 basic rights of the consumers can be enumerated in the following lines:
          <ul>
            <li><strong>Right to safety.</strong> </li>
            <li><strong>Right to basic needs.</strong></li>
            <li><strong>Right to choose.</strong></li>
            <li><strong>Right to information.</strong> </li>
            <li><strong>Right to representation.</strong> </li>
            <li><strong>Right to seek redressal.</strong> </li>
            <li><strong>Right to healthy environment.</strong> </li>
            <li><strong>Right to consumer education.</strong> </li>
          </ul>
          {/* abc */}
        </p>
      </div>

      {/* First Row of Buttons */}
      <div className="button-row">
        <FaAngleDoubleLeft className="scroll-icon left" onClick={() => scrollLeft(buttonContainerRef1)} />
        <div className="button-container" ref={buttonContainerRef1}>
          <button className="big-button">Consumer Protection Act, 2019</button>
          <button className="big-button" onClick={() => navigate('/family-law')}>
          Consumer Protection Act, 1986
          </button>
          {/* <button className="big-button">Banking Regulation Act, 1949</button> */}
          <button className="big-button" onClick={() => navigate('/search')}>
            Search area
          </button>
        </div>
        <FaAngleDoubleRight className="scroll-icon right" onClick={() => scrollRight(buttonContainerRef1)} />
      </div>

      {/* Second Row of Buttons */}
      {/* <div className="button-row">
        <FaAngleDoubleLeft className="scroll-icon left" onClick={() => scrollLeft(buttonContainerRef2)} />
        <div className="button-container" ref={buttonContainerRef2}>
          <button className="big-button">Insurance Act, 1938</button>
          <button className="big-button">Competition Act, 2002</button>
          <button className="big-button">Indian Electricity Act, 1910</button>
          <button className="big-button" onClick={() => navigate('/search')}>
            Search area
          </button>
        </div>
        <FaAngleDoubleRight className="scroll-icon right" onClick={() => scrollRight(buttonContainerRef2)} />
      </div> */}
    </div>
  );
};

export default CivilLaw;
